/** @format */

export const INITIAL_SHOWN_COUNT = 8;
export const DEFAULT_TEST_ID = 'product-price-modifiers';
